import Link from "next/link";
import { FiPhoneCall } from "react-icons/fi";
import { HiChat } from "react-icons/hi";
const CallChat = ({showCallBtn = true , showChatBtn = true }) => {
  return (
    <div className="fixed bottom-0 flex sm:hidden w-full -ml-2 z-10">
      {showCallBtn === true && <Link prefetch={false}
        href="tel:1800-309-3333"
        className="bg-nivabupa-blue-ethinosPlanRecommendation p-1 flex items-center justify-center flex-1 gap-2 text-white font-semibold"
      >
        <FiPhoneCall />
        Call
      </Link>}
      {showChatBtn === true && <Link prefetch={false}
        href="https://transaction.nivabupa.com/pages/chatbot.aspx"
        className="bg-white p-1 flex items-center justify-center flex-1 gap-2 text-nivabupa-blue-ethinosPlanRecommendation font-semibold"
      >
        <HiChat />
        Chat
      </Link>}
    </div>
  );
};

export default CallChat;
